module.exports = __webpack_public_path__ + "static/media/icon_themes.27287cb8.svg";